module.exports = {"id":"183483","name":"Konstantinos Mitroglou","rating":"78","photo":"./data/images/photos/3/183483.png","club":{"name":"OM","logo":"./data/images/clubs/OM.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KonstantinosMitroglou0.json
// module id = 2401
// module chunks = 0